export class NotificationTypeAction {
    actionType: string;
    actionValue: string;
    displayText: string;
    id: number;
    isDefault: boolean;
    notificationTypeId: string;
}

export class NotificationType {
    color: string;
    id: string;
    name: string;
    notificationTypeActions: Array<NotificationTypeAction>;
}

export class NotificationModel {
    accountNumber: string;
    branch: string;
    channelEntry: string;
    creationDate: Date;
    data: any;
    deletedDate: Date;
    description: string;
    fromUser: string;
    id: number;
    insuredName: string;
    isDeleted: boolean;
    isRead: boolean;
    isSeen: boolean;
    jobNumber: string;
    jobSubType: string;
    licensePlate: string;
    notificationGroup: string;
    notificationGroupId: string;
    notificationType: NotificationType;
    notificationTypeId: string;
    operationNumber: string;
    organizerCode: string;
    policyNumber: string;
    policyPeriodId: string;
    policyType: string;
    producerCode: string;
    readDate: Date;
    receivedDate: Date;
    risk: string;
    seenDate: Date;
    termNumber: number;
    toUser: string;

    constructor(data?: any) {
        this.accountNumber = null;
        this.branch = null;
        this.channelEntry = null;
        this.creationDate =  null;
        this.data = null;
        this.deletedDate = null;
        this.description = null;
        this.fromUser = null;
        this.id = null;
        this.insuredName = null;
        this.isDeleted = null;
        this.isRead = null;
        this.isSeen = null;
        this.jobNumber = null;
        this.jobSubType = null;
        this.licensePlate = null;
        this.notificationGroup = null;
        this.notificationGroupId = null;
        this.notificationType = null;
        this.notificationTypeId = null;
        this.operationNumber = null;
        this.organizerCode = null;
        this.policyNumber = null;
        this.policyPeriodId = null;
        this.policyType = null;
        this.producerCode = null;
        this.readDate = null;
        this.receivedDate = null;
        this.risk = null;
        this.seenDate = null;
        this.termNumber = null;
        this.toUser = null;

        if (typeof data !== 'undefined') {
            for (const i in data) {
                if (this.hasOwnProperty(i)) {
                    this[i] = data[i];
                }
            }
        }
    }
}

export class PaymentRequestEvent {
    producerCode: string;
    transitoryRejectedCount: number;
    definitiveRejectedCount: number;
  }
